import React from "react";
import { Plus } from "lucide-react";

// Shared card shell for every Professional Profile section — title + optional
// "Agregar" action, with a real empty state instead of a bare blank space.
export function ProfileSectionCard({ title, testId, onAdd, addLabel, isEmpty, emptyMessage, emptyActionLabel, onEmptyAction, children }) {
  return (
    <div data-testid={testId} style={{ background: "white", border: "1px solid #E5E7EB", borderRadius: "16px", padding: "20px 24px", boxShadow: "0 1px 3px rgba(0,0,0,0.05)" }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "14px", gap: "10px" }}>
        <h3 style={{ fontSize: "15px", fontWeight: 700, color: "#0F172A", fontFamily: "Poppins, sans-serif" }}>{title}</h3>
        {onAdd && (
          <button type="button" onClick={onAdd} data-testid={`${testId}-add-button`} aria-label={addLabel}
            style={{ display: "flex", alignItems: "center", gap: "5px", height: "32px", padding: "0 12px", background: "#EFF6FF", color: "#028CF8", border: "none", borderRadius: "8px", fontSize: "12px", fontWeight: 700, fontFamily: "Poppins, sans-serif", cursor: "pointer", flexShrink: 0 }}>
            <Plus className="h-3.5 w-3.5" /> <span className="hidden sm:inline">{addLabel}</span>
          </button>
        )}
      </div>
      {isEmpty ? (
        <div style={{ textAlign: "center", padding: "18px 10px" }} data-testid={`${testId}-empty-state`}>
          <p style={{ fontSize: "13px", color: "#94A3B8", fontFamily: "Poppins, sans-serif", marginBottom: onEmptyAction ? "12px" : 0 }}>{emptyMessage}</p>
          {onEmptyAction && (
            <button type="button" onClick={onEmptyAction} data-testid={`${testId}-empty-action-button`}
              style={{ height: "36px", padding: "0 16px", background: "#028CF8", color: "white", border: "none", borderRadius: "9px", fontSize: "12px", fontWeight: 700, fontFamily: "Poppins, sans-serif", cursor: "pointer" }}>
              {emptyActionLabel}
            </button>
          )}
        </div>
      ) : children}
    </div>
  );
}
